import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/client";
// Self-hosted fonts (no external font server needed)
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/fraunces/500.css";
import "@fontsource/fraunces/600.css";
import "./index.scss";
// import 'bootstrap/dist/css/bootstrap.min.css';
import AuthProvider from "contexts/AuthContext";
import FSBToastify from "components/common/FSBToastify";
import TabProvider from "contexts/TabContext";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import client from "./config/apollo";
import "font-awesome/css/font-awesome.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-bootstrap-typeahead/css/Typeahead.css";

ReactDOM.render(
  <AuthProvider>
    <TabProvider>
      <ApolloProvider client={client}>
        <App />
        <FSBToastify />
      </ApolloProvider>
    </TabProvider>
  </AuthProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
